import { COLORS, TYPE, SPACE } from './tokens'

// Rendered when `has_cyber_insurance = false` OR when no v2 review exists yet.
export default function EmptyState({ reason = 'no-coverage' }) {
  const message = reason === 'no-coverage'
    ? 'Toggle on to upload a policy and run a Specialist review.'
    : 'No Specialist review has been run against the current policy term. Run a review from the Documents tab to populate this view.'
  return (
    <div style={{
      maxWidth: SPACE.sectionMaxWidth, margin: '0 auto', padding: '80px 32px',
      textAlign: 'left', color: COLORS.mutedText
    }}>
      <p style={{ ...TYPE.lead, color: COLORS.bodyText, marginBottom: '12px' }}>
        {reason === 'no-coverage' ? 'No coverage on file.' : 'No v2 review on file.'}
      </p>
      <p style={{ ...TYPE.body, color: COLORS.mutedText }}>{message}</p>
    </div>
  )
}
